import { markMeta } from "./loadable";
export var loadByChunkname = function (chunkName) { return (Promise.all(markMeta
    .filter(function (meta) { return meta.chunkName === chunkName; })
    .map(function (meta) { return meta.loadable.load(); }))); };
